// extracted by mini-css-extract-plugin
module.exports = {"header":"OWegp","backButton":"_3HPsX","searchInputContainer":"_1dBWT","input":"_3SLoZ","icon":"yw1LJ"};